import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/gaurd/auth.guard';
import { AuthEmployerGuard } from 'src/app/gaurd/auth-employer.guard';
import { CvReviewLandingComponent } from './cv-review-landing/cv-review-landing.component';
import { CvSelectorComponent } from './cv-selector/cv-selector.component';
import { CvPreviewComponent } from './cv-preview/cv-preview.component';

const routes: Routes = [
  {
    path: '',
    component: CvReviewLandingComponent,
  },
  {
    path: 'cv-selector',
    component: CvSelectorComponent,
  },
  {
    path: 'cv-preview',
    component: CvPreviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CvReviewRoutingModule {}
